import React from "react";
import check from "../../images/hireDeveloper/check.svg";
import { getSkillData } from "./getconstdata";

const Userskill = ({ getData, getAnotherSkill, getOnSave }) => {
  const onIconSelect = (id) => {
    if (getData.includes(id))
      getOnSave(
        "userskill",
        getData.filter((a) => a !== id)
      );
    else if (id === 10) getOnSave("userskill", [id]);
    else if (id !== 10)
      getOnSave("userskill", [...getData.filter((a) => a !== 10), id]);
  };

  return (
    <>
      <section className="getSkillSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>2. Choose The Job Roles You Are Looking To Apply For</h4>
              </div>
            </div>
          </div>
          <div className="row">
            {getSkillData.map((m) => (
              <div className="col-lg-2 col-md-3 col-sm-3 col-6 mb-4" key={m.id}>
                <div
                  className={`techIcon ${
                    getData.includes(m.id) ? "active" : ""
                  }`}
                  onClick={() => onIconSelect(m.id)}
                >
                  <img src={m.images} alt="Hire Mobile App Developers" />
                  <p>{m.name}</p>
                  <div className="checkBox">
                    <img src={check} alt="Hire Asp.Net Developers" />
                  </div>
                </div>
              </div>
            ))}

            <div
              className={`col-lg-2 col-md-3 col-sm-3 skillForm ${
                getData.includes(10) ? "d-flex" : "d-none"
              }`}
            >
              <form className="form-inline d-block d-sm-flex">
                <div className="form-group mb-0">
                  <input
                    type="text"
                    className="form-control"
                    name="needhelp"
                    placeholder="Enter Other Skills"
                    value={getAnotherSkill}
                    onChange={(e) =>
                      getOnSave("getAnotherSkill", e.target.value)
                    }
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Userskill;
